import { Modal, Spinner } from '@enterprise-ui/canvas-ui-react'
import { MicroFrontend } from '@praxis/component-microfrontend'
import { MODES } from '../../../constants/downloadConstants'

// TODO: Replace with <ContentModalLauncher /> from item-component post migration to Canvas 8
export const DownloadItemDataModal = ({
  isOpen,
  onClose,
  downloadContext,
  src,
  selectedTcins,
  selectedItems,
  selectedItemCount,
}) => (
  <Modal
    isVisible={isOpen}
    headingText="Download item data"
    onRefuse={onClose}
    size="dense"
  >
    <div style={{ minHeight: '180px' }}>
      {isOpen && (
        <MicroFrontend
          src={src}
          module="./downloadItemDataStandard"
          Loading={Spinner}
          summaryText={
            downloadContext?.mode === MODES.SELECTED_ITEMS
              ? `${selectedItemCount} item${selectedItemCount === 1 ? '' : 's'} selected`
              : 'Download item data for current search results'
          }
          selectedTcins={selectedTcins}
          renderAsModalBody={true}
          selectedItems={selectedItems}
          mode={downloadContext?.mode}
          totalCount={downloadContext?.totalCount}
          itemTypeCounts={
            downloadContext?.mode === MODES.ALL_ITEMS
              ? downloadContext?.itemTypeCounts || []
              : []
          }
          searchCriteria={downloadContext?.searchCriteria}
        />
      )}
    </div>
  </Modal>
)
